import React from "react";
import { useEffect, useState } from "react";
import { setGoHome, setLoader, setLoginRequired } from "../../action/homeAction";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { CMSPath } from "../../../config/constant";
import { sendAnalytics } from "../../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import moment from "moment";
import { scrollToTop } from "../../../JS/scrollToTop";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { currentWidget, popupOpenClose, setRegPage } from "../../../action/action";
import { format } from "date-fns";
import { bookEvent, getAllAvailableEvents, getMyEventsReservations } from "../../../action/events7rooms";
import Event1_ListEvents from "./Event1_ListEvents";
import Event2_MyReservations from "./Event2_MyReservations";
import Event3_ListVenues from "./Event3_ListVenues";
import Event4_PreferredAvailability from "./Event4_PreferredAvailability";
import Event6_AdditionalInfo from "./Event6_AdditionalInfo";
import Event7_Summary from "./Event7_Summary";
import Event8_Success from "./Event8_Success";
import { filterEvent, formatResponseForAvailableEvents, getClientDetailsForEventCreation, isFirstReservation } from "./helpers";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import Loader from "../../UI/loader";



export const ClientInfoLS_Key = "eventsReservationClientId";
export const Events_Clients_Details_tempKey="eventsClientsDetails_Temp";
//TODO; remove testPhoneNumber; and its variable everywhere
// export const DUMMYPHONENUMBER= "2124567890"


function Events(props) {




    // useStates
    const [currencyPage, setCurrentPage] = useState(1);
    const [availableEvents, setAvailableEvents] = useState(null);
    // const [eventDataToBeRendered, setEventDataToBeRendered] = useState(null);

    // const [selectedEventAndInventory, setSelectedEventAndInventory] = useState(null);
    const [selectedEvent, setSelectedEvent]=useState(null);

    const [myReservations, setMyReservations] = useState(null)

    const [selectedVenue, setSelectedVenue] = useState(null);
    const [inventoryList, setInventoryList]=useState(null)
    const [selectedInventory, setSelectedInventory]=useState(null);

    const [preferredDateTime, setPreferredDateTime] = useState({ guestCount: '1', date: '' }); // remember tocheck date if null, check cout is string
    // const [availableDateTime, setAvailableDateTime] = useState(null);

    const [additionalInfo, setAdditionalInfo] = useState({
        firstName: "",
        lastName: "",
        email: "",
        guestComment: '',
        phoneNumber:''

    })
    //Todo:  also add phoneNumber in additonal info
 
    const [showLoader, setShowLoader] = useState(false);
    const [showLoaderForPromises,setShowLoaderForPromises]=useState(false);
    const [showFailScreen, setShowFailScreen] = useState(false);
    const [displayLoadingMsg, setDisplayLoadingMsg] = useState('')

    const [isFetchingMyReservation, setIsfetchingMyReservation] = useState(false);



    


    // API Methods


    const fetchAllAvailableEvents = async (cbResolve, cbReject) => {
        setShowLoader(true);
        setShowFailScreen(false);
        setDisplayLoadingMsg("Fetching Events..")

        await getAllAvailableEvents() // checkPayload
            .then((res) => {
                if (res && res.status == 200 && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS") { // add other checkers
                    console.log("getAllAvailableEvents", JSON.stringify(res))

                    const eventsList =  formatResponseForAvailableEvents(res.data.payload.data.venues)
                    setAvailableEvents(eventsList)
                    if(cbResolve)cbResolve();

                    // setEventDataToBeRendered(eventsList)
                } else {
                    console.log("eerror")
                    throw new Error(
                        res.data && res.data.header && res.data.header.status && res.data.header.status.msg
                        ||
                        res.response && res.response.data && res.response.data.header && res.response.data.header.status && res.response.data.header.status.msg
                        ||
                        t("events.error.getAllAvailableEvents")

                    )
                }
 
             })
            .catch((err) => {
                console.log("error came")
                setShowFailScreen(true);
                sendTheAnalytics("get All Available Events ", false, err)
                if(cbReject)cbReject();
            })
            .finally(() => {
                setShowLoader(false);
                setDisplayLoadingMsg('')
            })
    }


    const fetchMyReservations = (delay,cbResolve,cbReject) => {
 
        if(isFirstReservation()){
            setMyReservations([]);
            if(cbResolve)cbResolve();
            return;
        }

        setIsfetchingMyReservation(true);

        let payload={};
        
        if(localStorage.getItem(ClientInfoLS_Key) && localStorage.getItem(ClientInfoLS_Key)!='' && localStorage.getItem(ClientInfoLS_Key)!="null" )
        {
            const clientId= localStorage.getItem(ClientInfoLS_Key);
            payload.clientId=clientId; 
        }else{
            const clientDetails= JSON.parse(localStorage.getItem(Events_Clients_Details_tempKey));
            payload.guestName= clientDetails.firstName + ' ' + clientDetails.lastName;
            payload.guestEmail= clientDetails.email;
        }
        
             
        setTimeout(() => {

            getMyEventsReservations(payload)
                .then((res) => {
                    // check if 200, validatee fields 
                    //if all good return data
                    if (res && res.status == 200 && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS" && res.data.payload && res.data.payload.data && res.data.payload.data.results) { // add other checkers
                        if(!Array.isArray(res.data.payload.data.results)){
                            throw new Error();
                        }
                        const events_= res.data.payload.data.results.filter((e)=> e.hasOwnProperty("event") &&  e.event!=null)
                        setMyReservations(events_);
                        if(events_.length>0 && events_[0].clientId){
                            localStorage.setItem(ClientInfoLS_Key,events_[0].clientId)
                            localStorage.removeItem(Events_Clients_Details_tempKey);
                        }
                        if(cbResolve)cbResolve();
                         
                    } else {
                        throw new Error(
                            res.data && res.data.header && res.data.header.status && res.data.header.status.msg
                            ||
                            res.response && res.response.data && res.response.data.header && res.response.data.header.status && res.response.data.header.status.msg
                            ||
                            t("events.error.getMyEventsReservations")
    
                        )
                    }
    
                })
                .catch((err) => {
    
                    //send analytics
                    sendTheAnalytics("Fetch my Reservations", false, err)
                    // pop that got fails
                    props.closeOrderPopUp(true, err || t('events.error.getMyEventsReservations'), "", true);

                    if(cbReject)cbReject();
    
                })
                .finally(() => {
                    setIsfetchingMyReservation(false);
                })

        }, delay*1000);

    }

    const bookMyEvent = async () => {
        setShowLoader(true)
        setDisplayLoadingMsg("Booking your event..")

        
        // const clientDetails= JSON.parse(localStorage.getItem(Events_Clients_Details));
        console.log(preferredDateTime.date, "preferredDateTime.date");
        console.log(moment(preferredDateTime.date).format("YYYY-MM-DD"), 'moment(preferredDateTime.date).format("YYYY-MM-DD")');
        const payload = {

            "venueId": selectedVenue.venueId,
            "eventId": selectedEvent.eventId,
            "firstName": isFirstReservation() ? additionalInfo.firstName :  (myReservations && myReservations.length>0 && myReservations[0] &&  myReservations[0].first_name || ''),

            "lastName":isFirstReservation() ? additionalInfo.lastName :  (myReservations && myReservations.length>0 && myReservations[0] &&  myReservations[0].last_name || ''),

            "email":  isFirstReservation() ? additionalInfo.email :  (myReservations && myReservations.length>0 && myReservations[0] &&  myReservations[0].email || ''),

            "guestCount": Number(preferredDateTime.guestCount),
            "date": moment(preferredDateTime.date).format("YYYY-MM-DD"),//"2024-06-12" check  if formatted
            "guestComment": additionalInfo.guestComment,
            "inventoryId": selectedInventory.id,
            "phoneNumber": (isFirstReservation() || myReservations[0].phone_number=='') ? additionalInfo.phoneNumber :  (myReservations && myReservations.length>0 && myReservations[0] &&  myReservations[0].phone_number || ''),

        }

        await bookEvent(payload)
            .then((res) => {
                // check if 200, validatee fields 
                //if all good return data

                //if 200 and not in localstorage, save there

                if (res && res.status == 200 && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS") { // add other checkers

                    const clientId= res.data.payload && res.data.payload.data && res.data.payload.data.clientId;
                    if(clientId){
                        localStorage.setItem(ClientInfoLS_Key,clientId);
                    }else{
                        localStorage.setItem(Events_Clients_Details_tempKey,JSON.stringify({
                            firstName:payload.firstName,
                            lastName:payload.lastName,
                            email:payload.email,
                            phoneNumber:payload.phoneNumber
                        }))
                    }
                    sendTheAnalytics("Book Event", true, undefined , {inventoryName: selectedInventory && selectedInventory.inventory_name, "inventoryId": selectedInventory && selectedInventory.id} )

                } else {
                    throw new Error(
                        res.data && res.data.header && res.data.header.status && res.data.header.status.msg
                        ||
                        res.response && res.response.data && res.response.data.header && res.response.data.header.status && res.response.data.header.status.msg
                        ||
                        t("events.error.bookEvent")

                    )
                }
            })
            .catch((err) => {
                sendTheAnalytics("Book Event", false, err, {inventoryName: selectedInventory && selectedInventory.inventory_name , "inventoryId": selectedInventory && selectedInventory.id} )

                throw err
            })
            .finally(() => {
                setShowLoader(false);
                setDisplayLoadingMsg("")
            })
    }


    //Handle Next
    const handleNext = () => {

        if (currencyPage == 8) {
            //call fetchmyresevation and setmyreservation
            fetchMyReservations(7);
            setCurrentPage(2)
            return;
        }
        if (currencyPage == 4) {
            setCurrentPage(6);
            return;
        }

        setCurrentPage(currencyPage + 1)

    }

    // Handle Back
    const handleBack = () => {

        if (currencyPage == 8) {
            //call fetchMyreservaton and setmyrsevtion
            return;
        }
        if (currencyPage == 6) {
            setCurrentPage(4);
            return;
        }
        if (currencyPage == 2) {
            // check in future if needed
            setSelectedEvent(null);

            setSelectedInventory(null);
            setSelectedVenue(null);
            setInventoryList(null);
            setSelectedInventory(null);
            // setSelectedDateTime(null);
            setPreferredDateTime({ guestCount: '1', date: '' })
            // setAvailableDateTime(null);
            setIsfetchingMyReservation(false)
        
            if(availableEvents && availableEvents.length==1){
                props.setGoHome(true);
            }

        }

        if (currencyPage != 1) setCurrentPage(currencyPage - 1)
        else props.setGoHome(true);

    }

    const startFlow = async () => {
        console.log("staring events flow")
        setShowLoader(false);
        setShowFailScreen(false);
        setShowLoaderForPromises(true);
        const fetchAllEventsPromise= new Promise((resolve, reject)=>{
            fetchAllAvailableEvents(resolve,reject)
        })

        const fetchMyReservationsPromise= new Promise((resolve, reject)=>{
            fetchMyReservations(0,resolve,reject);
        })

        Promise.all([fetchMyReservationsPromise,fetchAllEventsPromise]).then(
            ()=>{ console.log("both done promise"); setShowFailScreen(false); setShowLoaderForPromises(false) }
            ,
            ()=>{ setShowFailScreen(true); setAvailableEvents(null); setShowLoaderForPromises(false)}
        )
    }



    //Helpers
    const { t } = props;

    let room = localStorage.getItem("room");
    let widgetSesstionId = localStorage.getItem("eventsBookingSessionToken");
    let label = getDefaultAnalyticsLabel({
        appVersion: props.installedAppVersion
            ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
            : "",
    });

    const sendTheAnalytics = (taskName, isSuccess, msg, otherDetails={}) => {
        try {

            props.sendAnalytics(
                props.guestDetail,
                props.currentWidgets.widgetType,
                `${taskName} ${isSuccess ? "Success" : "Failure"}`,
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, errorMsg: msg, ...otherDetails },
                0,
                props.guestIsLoggedIn
            );
        } catch (error) {
            return error;
        }

    }

    






    //useEffect
    useEffect(() => {
        let room = localStorage.getItem("room");
        console.log("props.allowWalkInGuestRestaurantBooking",props.allowWalkInGuestRestaurantBooking)
        if(toBool(props.allowWalkInGuestRestaurantBooking)){
            startFlow();
        } else {
            if (room && room != "null") {
                startFlow();
            } else {
                if (process.env.REACT_APP_INROOMTAB == "true") {
                    props.setLoginRequired(true)
                } else {
                    props.setRegPage(true);
                }
            }
        }

    }, [])

     
 
    return (<>
        {
            showFailScreen
                ?
                <SuccessFailScreen
                    status={false}
                    showTryAgain={false}
                    showClose={true}
                    statusMessage1={t(`events.error.error`)}
                    statusMessage2={
                        t("events.error.unable_process_request")
                    }
                    close={props.setGoHome}

                />
                :

                <>

                    {currencyPage == 1 &&
                        <Event1_ListEvents
                            availableEvents={availableEvents}
                            selectedEvent={selectedEvent}
                            setSelectedEvent={setSelectedEvent}                      
                            next={handleNext}
                            back={handleBack} /> 
                             
                    }
                    {currencyPage == 2 &&
                        <Event2_MyReservations
                            myReservations={myReservations}
                            isFetchingMyReservation={isFetchingMyReservation}
                            selectedEvent={selectedEvent}                            
                            fetchMyReservations={fetchMyReservations}
                            next={handleNext}
                            back={handleBack} /> // dont' procedd with no available Venue from api
                    }
                    {currencyPage == 3 &&
                        <Event3_ListVenues
                            selectedEvent={selectedEvent}
                            setSelectedVenue={setSelectedVenue}
                            selectedVenue={selectedVenue}
                            selectedInventory={selectedInventory}
                            setSelectedInventory={setSelectedInventory}
                            inventoryList={inventoryList}
                            setInventoryList={setInventoryList}
                            next={handleNext}
                            back={handleBack} />
                    }
                    {currencyPage == 4 &&
                        <Event4_PreferredAvailability
                        // selectedInventory={selectedInventory}
                        // setSelectedInventory={setSelectedInventory}
                        selectedEvent={selectedEvent}
                        selectedVenue={selectedVenue}
                            preferredDateTime={preferredDateTime}
                            setPreferredDateTime={setPreferredDateTime}
                            // fetchAvailableDateTime={fetchAvailableDateTime}
                            next={handleNext}
                            back={handleBack} />
                    }
                    {/* {currencyPage == 5 &&
                        <Event5_Availability
                            availableDateTime={availableDateTime}
                            selectedDateTime={selectedDateTime}
                            setSelectedDateTime={setSelectedDateTime}
                            next={handleNext}
                            back={handleBack}
                        />
                    } */}
                    {currencyPage == 6 &&
                        <Event6_AdditionalInfo
                            myReservations={myReservations}
                            additionalInfo={additionalInfo}
                            setAdditionalInfo={setAdditionalInfo}
                            next={handleNext}
                            back={handleBack}
                        />
                    }
                    {currencyPage == 7 &&
                        <Event7_Summary
                            selectedEvent={selectedEvent}
                            selectedVenue={selectedVenue}
                            selectedInventory={selectedInventory}
                            // selectedDateTime={selectedDateTime}
                            preferredDateTime={preferredDateTime}
                            additionalInfo={additionalInfo}
                            bookMyEvent={bookMyEvent}
                            next={handleNext}
                            back={handleBack}

                        />
                    }
                    {currencyPage == 8 &&
                        <Event8_Success
                            selectedEvent={selectedEvent}
                            next={handleNext}
                            back={handleBack} />
                    }
                </>
        }
        { (showLoader || showLoaderForPromises) && <Loader displayMsg={displayLoadingMsg} />}
    </>)
}
const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        serverTimeDate: state.store.home.serverTimeDate.date,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        menuColor: state.store.home.MenuColor,
        currencyCode: state.store.home.clientConfig.currencyDetails
            ? state.store.home.clientConfig.currencyDetails.code
            : "",
        allowWalkInGuestRestaurantBooking: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.restaurantReservationConfigs ? state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.restaurantReservationConfigs.allowWalkInGuestRestaurantBooking : false,

 

    }
}

const mapDispatchToProps = { setGoHome, closeOrderPopUp, sendAnalytics, popupOpenClose,setLoginRequired, setRegPage }

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('translations')(Events));
